import AppComponentHeader from '@crema/components/AppComponentHeader';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useGetDataApi } from '@crema/hooks/APIHooks';
import { Stack, Alert, DialogActions, Button, Typography } from '@mui/material';
import * as yup from 'yup';
import { useSearchParams } from 'react-router-dom';
import { Form, Formik, FormikValues } from 'formik';
import Dialog from '@pod/components/Dialog';

type ConfirmModalProps = {
  setOpen?: boolean;
  onClose?: () => void;
};

const ConfirmModal = (props: ConfirmModalProps) => {
  const { setOpen = false, onClose } = props;
  const [searchParams] = useSearchParams();

  const handleCancelClick = () => {
    if (onClose) onClose();
  };

  return (
    <Dialog maxWidth="md" isOpen={setOpen}>
      {/* <Dialog.Title
      title={'Dialog Title'}
      subtitle={'Dialog Subtitle'}
      notUseCloseIcon={false}
    /> */}
      <Dialog.Content dividers={false} fullHeight={false}>
        <Dialog.Title title={'Cafe24 인증을 진행할 수 없습니다.'} onClose={handleCancelClick} />

        <Stack spacing={2}>
          <Alert severity="info">
            카페24 Shop 관리자 메뉴를 통해 접근하지 않을 경우 앱 설치가 완료되지 않습니다.
            <br />
            앱 설치를 완료하지 않은 상태로 서비스를 계속 이용하실 수 있으나, 페이지를 새로고침하면 Cafe24 인증페이지로
            강제 이동됩니다.
            <br /> (인증 없이 설정한 데이터는 계속 유지됩니다.)
          </Alert>
        </Stack>
        <span></span>
      </Dialog.Content>
      {/* <DialogActions>
        <Button onClick={() => handleCancelClick()}>홈으로</Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default ConfirmModal;
